<div class="flex items-center justify-center gap-3 md:gap-5 text-primary">
  <button
    type="button"
    (click)="previousPage()"
    [disabled]="currentPage === 0"
    class="w-8 h-8 rounded-full flex items-center justify-center transition-opacity"
    [ngClass]="{
      'bg-lightmabe opacity-50 cursor-not-allowed': currentPage === 0,
      'bg-secondary hover:bg-primary': currentPage !== 0
    }"
    aria-label="Página anterior"
  >
    <img src="assets/images/icon-back.svg" class="w-5 h-5" alt="" />
  </button>

  <button
    type="button"
    *ngFor="let page of visiblePages"
    (click)="goToPage(page)"
    class="w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium transition-colors"
    [ngClass]="{
      'bg-primary text-white': currentPage === page,
      'bg-transparent text-primary hover:bg-white': currentPage !== page
    }"
  >
    {{ page + 1 }}
  </button>

  <button
    type="button"
    (click)="nextPage()"
    [disabled]="currentPage === totalPages - 1"
    class="w-8 h-8 rounded-full flex items-center justify-center transition-opacity"
    [ngClass]="{
      'bg-lightmabe opacity-50 cursor-not-allowed': currentPage === totalPages - 1,
      'bg-secondary hover:bg-primary': currentPage !== totalPages - 1
    }"
    aria-label="Página siguiente"
  >
    <img src="assets/images/icon-back.svg" class="w-5 h-5 rotate-180" alt="" />
  </button>
</div>
